var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentCardPaymentComponent,{ref:"cardPayment",tag:"component",attrs:{"facility":_vm.facility,"booking_details":_vm.booking_details,"confirm":_vm.confirm,"currency":_vm.currency,"touchdown":_vm.touchdown,"page":_vm.page,"settings":_vm.configs}})
}
var staticRenderFns = []

export { render, staticRenderFns }